import { render, staticRenderFns } from "./territory.vue?vue&type=template&id=6662ce6a&scoped=true&"
import script from "./territory.vue?vue&type=script&lang=js&"
export * from "./territory.vue?vue&type=script&lang=js&"
import style0 from "./territory.vue?vue&type=style&index=0&id=6662ce6a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6662ce6a",
  null
  
)

export default component.exports